export const findMissingIndexes = (arr) => {
  const missingIndexes: number[] = [];
  for (let i = 0; i < arr.length; i++) {
    if (!(i in arr)) {
      missingIndexes.push(i);
    }
  }
  return missingIndexes;
};
